import SignupForm from "../Components/SignupForm";

const SignUpPage = () => {
  return (
    <div className="signupBox">
      <SignupForm />
    </div>
  );
};

export default SignUpPage;
